export const bsContractChEn = {
    'APPLY': '待审核',
    'REJECTED': '已驳回',
    'SIGN_FLOW_INITIATED': '签署发起成功',
    'OPERATOR_READ': '甲方已读',
    'SIGNED': '签署完成',
    'RETRACTED': '已撤销',
    'EXPIRED': '已过期',
    'INITIATION_FAILED': '签署发起失败',
    'AUTO': '自流转',
    'NOT_APPLYING': '未申请',
    'VISA_REFUSAL': '拒签',
    '待审核': 'APPLY',
    '已驳回': 'REJECTED',
    '签署发起成功': 'SIGN_FLOW_INITIATED',
    '甲方已读': 'OPERATOR_READ',
    '签署完成': 'SIGNED',
    '已撤销': 'RETRACTED',
    '已过期': 'EXPIRED',
    '签署发起失败': 'INITIATION_FAILED',
    '自流转': 'AUTO',
    '未申请': 'NOT_APPLYING',
    '拒签': 'VISA_REFUSAL'
}
export const rawDataStatusIconList={
    'NO_DATA':{
        iconClass: 'my-icon',
        displayName: '无',
        class: 'status-tag tag-none',
        colorClass:'tag-none',
        isMyIcon:true,

    },'NOT_RELEASED':{
        iconClass: 'el-icon-lock',
        displayName: '未释放',
        class: 'status-tag tag-unreleased',
        colorClass:'tag-unreleased'
    },
    'LINK_RELEASED':{
        iconClass: 'el-icon-link',
        displayName: '链接释放',
        class: 'status-tag tag-link-released',
        colorClass:'tag-link-released'

    },
    'HDD_RELEASED':{
        iconClass: 'el-icon-folder',
        displayName: '硬盘释放',
        class: 'status-tag tag-disk-released',
        colorClass:'tag-disk-released'
    }
}
